module.exports = __webpack_public_path__ + "fd5cf2468389bcb037038b1cd43aa095.svg";